/**
 * Coordinates typed by hand, for when geolocation is refused.
 */
export interface ParsedCoordinates {
  lat: number
  lon: number
}

export function parseCoordinates(input: string): ParsedCoordinates | null {
  const parts = (input ?? '').replace(/\s/g, '').split(',')
  if (parts.length !== 2) return null

  const lat = Number(parts[0])
  const lon = Number(parts[1])
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null
  if (lat < -90 || lat > 90 || lon < -180 || lon > 180) return null

  return { lat, lon }
}

export function formatDistance(meters: number | null): string {
  if (meters === null || !Number.isFinite(meters)) return ''
  if (meters < 1000) return `${Math.round(meters)} м`
  return `${(meters / 1000).toFixed(1)} км`
}

export function mapsLink(lat: number, lon: number): string {
  return `https://yandex.ru/maps/?pt=${lon},${lat}&z=16`
}
